import { Loader } from "@/shared/ui/Loader";

import { Suspense } from "react";

export function LazyPage({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<Loader />}>{children}</Suspense>;
}
